export var SUPPORTED_LOCALES = ['zh-CN', 'en', 'zh-TW'];

export var DEFAULT_LOCALE = 'zh-CN';

/** 与 visa-web-new 共用，跨应用语言一致 */
export var STORAGE_KEY_GUEST_LOCALE = 'visa_guest_locale';

export var LOCALE_OPTIONS = [
  { value: 'zh-CN', label: '简体中文' },
  { value: 'en', label: 'English' },
  { value: 'zh-TW', label: '繁體中文' },
];

export function isSupportedLocale(locale) {
  return SUPPORTED_LOCALES.indexOf(locale) !== -1;
}
